import React, { FC } from 'react';
import { Collapse } from '../Collapse/Collapse';
import { twMerge } from '@shared/utils/twMerge';

export type CollapsibleFormSectionProps = {
  className?: string;
  children?: React.ReactNode;
  title: string | React.ReactNode;
  resize?: number;
  styles?: {
    container?: string;
    header?: string;
    content?: string;
    icon?: string;
    iconBtn?: string;
  };
};

export const CollapsibleFormSection: FC<CollapsibleFormSectionProps> = ({
  children,
  title,
  styles = {},
  resize,
}) => {
  return (
    <Collapse
      open
      resize={resize}
      label={
        <header className='flex items-center justify-between'>
          <h2 className='font-poppins text-1824 font-medium'>{title}</h2>
        </header>
      }
      styles={{
        container: 'form mt-[2.4rem] max-w-[100%]',
        content: twMerge(
          'transition-all duration-300 overflow-hidden',
          styles.content
        ),
        header: twMerge(
          'bg-blueTone rounded-md p-[12px] h-[4.8rem] mb-[1.5rem]',
          styles.header
        ),
        iconBtn: 'w-3 h-3 rounded-full border bg-ghostWhite',
        icon: 'w-2 h-2',
      }}
    >
      {children}
    </Collapse>
  );
};
